// @ts-nocheck
/* eslint-enable */
const controller = {
  getMiddlePageNumbersToShow(currPageNum, totalPageNum, screenWidth) {
    const pageNumbers = [];

    if (screenWidth === 'sm') {
      if (totalPageNum < 5) {
        for (let i = 2; i < totalPageNum; i++) {
          pageNumbers.push(i);
        }
      } else if (currPageNum === 1 || currPageNum === 2) {
        for (let i = 2; i < 4; i++) {
          pageNumbers.push(i);
        }
      } else if (currPageNum === totalPageNum || currPageNum === totalPageNum - 1) {
        for (let i = totalPageNum - 2; i < totalPageNum; i++) {
          pageNumbers.push(i);
        }
      } else {
        for (let i = currPageNum - 1; i < currPageNum + 2; i++) {
          pageNumbers.push(i);
        }
      }
    } else {
      if (totalPageNum < 7) {
        // show every page
        // 1 is always shown
        for (let i = 2; i < totalPageNum; i++) {
          pageNumbers.push(i);
        }
      } else if (currPageNum === 1 || currPageNum === 2 || currPageNum === 3 || currPageNum === 4) {
        for (let i = 2; i < 6; i++) {
          pageNumbers.push(i);
        }
      } else if (
        currPageNum === totalPageNum ||
        currPageNum === totalPageNum - 1 ||
        currPageNum === totalPageNum - 2 ||
        currPageNum === totalPageNum - 3
      ) {
        for (let i = totalPageNum - 5; i < totalPageNum; i++) {
          pageNumbers.push(i);
        }
      } else {
        for (let i = currPageNum - 2; i < currPageNum + 3; i++) {
          pageNumbers.push(i);
        }
      }
    }
    return pageNumbers;
  },
  getMaxVisiblePage(currPageNum, totalPageNum, paginationUpperBound) {
    if (paginationUpperBound === 0) {
      return totalPageNum;
    }

    const currFactorOfUpperBound = Math.ceil(currPageNum / paginationUpperBound);
    const upperBound = currFactorOfUpperBound * paginationUpperBound;

    if (totalPageNum < paginationUpperBound) {
      return totalPageNum;
    }

    if (upperBound - currPageNum < 3) {
      const nextUpperBound = paginationUpperBound + upperBound;
      return nextUpperBound > totalPageNum ? totalPageNum : nextUpperBound;
    }

    return upperBound > totalPageNum ? totalPageNum : upperBound;
  },
  getFrontDotsBool(currPageNum, totalPageNum, screenWidth) {
    if (screenWidth === 'sm') {
      return currPageNum > 3 && totalPageNum > 5;
    } else {
      return currPageNum > 4 && totalPageNum > 6;
    }
  },
  getBackDotsBool(currPageNum, totalPageNum, screenWidth) {
    if (screenWidth === 'sm') {
      return currPageNum < totalPageNum - 2 && totalPageNum > 5;
    } else {
      return currPageNum < totalPageNum - 3 && totalPageNum > 6;
    }
  },
  isEdgePage(page, maxPage) {
    // checks if the page link is for prev/next buttons
    if (page - 1 === maxPage || page + 1 === 1) {
      return true;
    } else {
      return false;
    }
  },
};

export default controller;
